import {PlayerColor} from '@colonist/game-states'
import {StateCreator} from 'zustand'

export interface GameGeneralSlice {
    myColor: PlayerColor
    isMyColorSpectator: boolean
    timeLeftInSeconds: number
    setTimeLeftInSeconds: (timeLeftInSeconds: number) => void
}

export interface GameGeneralSliceProps {
    initialMyColor: PlayerColor
    initialTimeLeftInSeconds: number
}

export const createGameGeneralSlice = ({
    initialMyColor,
    initialTimeLeftInSeconds,
}: GameGeneralSliceProps): StateCreator<GameGeneralSlice> => (set) => ({
    myColor: initialMyColor,
    isMyColorSpectator: initialMyColor === PlayerColor.None,
    timeLeftInSeconds: initialTimeLeftInSeconds,
    setTimeLeftInSeconds: (timeLeftInSeconds: number) => {
        set({
            timeLeftInSeconds: timeLeftInSeconds,
        })
    },
})
